<template>
  <wegow-select
    id="language-selector"
    class="w-full mb-4"
    :background-select="backgroundSelect"
    :font-color="colorFont"
    :options="languages"
    :value="languageSelected"
    :placeholder="$t('wegow.headers.regionSelectorPlaceholder')"
    :no-options-label="$t('wegow.headers.regionSelectorNoLoad')"
    :no-result-label="$t('wegow.headers.regionSelectorNoResult')"
    object-label="text"
    :special-label="true"
    :special-single-label="true"
    border="1px solid #7F8295"
    track-by="value"
    @select="selectLanguage"
  >
    <template #option="data">
      <i :class="data.data.option.code" class="flag mr-2" />
      {{ data.data.option.text }}
    </template>
    <template #singleLabel="data">
      <i :class="data.data.option.code" class="flag mr-2" />
      {{ data.data.option.text }}
    </template>
  </wegow-select>
</template>

<script setup>
import { useUser } from "@/composables/useUser";

import WegowSelect from "@/components/general/forms/WegowSelect";

import { VueCookieNext } from "vue-cookie-next";
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";

let languages = ref([
  { value: "es", text: "Español", code: "es-es" },
  { value: "en", text: "English", code: "en-gb" },
  { value: "de", text: "Deutsch", code: "de-de" },
  { value: "fr", text: "Français", code: "fr-fr" },
  { value: "it", text: "Italiano", code: "it-it" },
  { value: "pt", text: "Português", code: "pt-pt" }
]);

const $cookie = VueCookieNext;
const i18n = useI18n();
const { userDetail, updateUser } = useUser();
const languageSelected = ref({ value: "es", text: "Español", code: "es-es" });

const props = defineProps({
  backgroundSelect: {
    type: String,
    default: ""
  },
  colorFont: {
    type: String,
    default: ""
  }
});

onMounted(async () => {
  setTimeout(() => {
    let lan = i18n.locale.value;
    languageSelected.value = languages.value.find(
      language => language.value === lan
    );
  });
});

const selectLanguage = async language => {
  languageSelected.value = language;
  i18n.locale.value = language.value;
  let match_expression =
    process.env.VUE_APP_NUXT_ENV !== "local" ? "https://www" : "http://www";
  $cookie.setCookie("wegow.user-language", language.value, {
    path: "/",
    expire: 60 * 60 * 24 * 365,
    domain: process.env.VUE_APP_NUXT_HOST.replace(match_expression, ""),
    secure: process.env.VUE_APP_NUXT_ENV !== "local"
  });
  if (userDetail.value.id) {
    await updateUser({ id: userDetail.value.id, language: language.value });
  }
};
</script>

<style lang="scss" scoped>
.flag {
  display: inline-block;
  width: 22px;
  height: 13px;
  margin-right: 5px;
  vertical-align: middle;
  background-position: center;
  background-size: contain;
  &.es-es,
  &.es {
    background-image: url("@/assets/images/es.svg");
  }
  &.de-de,
  &.de {
    background-image: url("@/assets/images/de.svg");
  }
  &.en-gb,
  &.gb {
    background-image: url("@/assets/images/gb.svg");
  }
  &.fr-fr,
  &.fr {
    background-image: url("@/assets/images/fr.svg");
  }
  &.it-it,
  &.it {
    background-image: url("@/assets/images/it.svg");
  }
  &.pt-pt,
  &.pt {
    background-image: url("@/assets/images/pt.svg");
  }
}
.transparent {
  background: transparent;
}
</style>
